module.exports = __webpack_public_path__ + "media/images/icons/SVG/035-e70feffa7e87b626139c74e5fc460aba.svg";